package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.Serializable

@Serializable
data class MeetingDTO(
    val id: Int? = null,
    val title: String = "",
    val meetingDate: String? = null,
    val status: Short = 1,
    val createdAt: String? = null,
    val createdBy: String? = null,
    val updatedAt: String? = null,
    val deletedAt: String? = null,
    val deletedBy: String? = null,
    val responseCount: Int = 0,
)
